Object.assign window,
  defaults: (target: Record<PropertyKey, unknown>, values: Record<PropertyKey, unknown>) ->
    Object.keys(values).forEach (key) ->
      unless Object.prototype.hasOwnProperty.call(target, key)
        target[key] = values[key]
    return target

Object.assign Blob.prototype,
  json: (this: Blob) ->
    JSON.parse await @text()
  download: (this: Blob, filename: string) ->
    url := URL.createObjectURL this
    a := document.createElement "a"
    a.href = url
    a.style.display = "none"
    a.download = filename
    document.body.appendChild a
    a.click()
    a.remove()
    URL.revokeObjectURL url
